/* eslint import/prefer-default-export: 0 */

// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const GraphsFetch = CreateProcess({
	method: "GET",
	name: "FetchGraphData",
	type: "GRAPHS:FETCH",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/graphs/${props.graphURL}/`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const GetMostActiveCompanies = CreateProcess({
	method: "GET",
	name: "GetMostActiveCompanies",
	type: "MostActiveCompanies:GET",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/graphs/most-active-companies/`,
		};
	},

	success: (response) => fromJS({ data: response.data.companyUserCounts }),
});

export const GetMostActiveUtilization = CreateProcess({
	method: "GET",
	name: "GetMostActiveUtilization",
	type: "MostActiveUtilization:GET",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/company-utilization/`,
		};
	},

	success: (response) => fromJS({ data: response.data.companyUtilization }),
});
